import {
    Fab,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import { FieldArray, FieldArrayRenderProps } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import FullWidthField from 'src/common/FullWidthField';
import { DefaultNote } from 'src/Definitions';
import { INoteDto } from 'src/generated_client';

interface INotesInlineListProps {
    notes: INoteDto[];
    setFieldValue: (field: string, value: INoteDto[], shouldValidate?: boolean) => void;
    noteGridStyle: string;
}

class NotesInlineList extends React.Component<INotesInlineListProps> {
    public addNotes = (
        setFieldValue: (field: string, value: INoteDto[], shouldValidate?: boolean) => void,
        notes: INoteDto[]
    ) => (_event: React.MouseEvent<HTMLElement>) => {
        if (!notes) {
            notes = [];
        }
        notes.unshift({
            ...DefaultNote(true),
        });
        setFieldValue('notes', notes);
    };

    public renderNotesArray = (notes: INoteDto[]) => {
        if (notes && notes.length > 0) {
            return <FieldArray name="notes" render={this.renderNotes(notes)} />;
        }
        return;
    };

    public archiveNote = (arrayHelpers: FieldArrayRenderProps, index: number) => (
        _event: React.MouseEvent<HTMLElement>
    ) => {
        arrayHelpers.remove(index);
    };

    public renderNotes = (notes: INoteDto[]) => (arrayHelpers: FieldArrayRenderProps) => {
        return notes.map((note: INoteDto, index: number) => {
            return (
                <List key={note.id}>
                    <ListItem dense divider>
                        {note.createdOn !== undefined ? (
                            <ListItemText
                                style={{
                                    hyphens: 'auto',
                                    overflowWrap: 'break-word',
                                    wordWrap: 'break-word',
                                }}
                                primary={note.text}
                                secondary={
                                    <Grid
                                        alignItems="center"
                                        container
                                        justify="space-between"
                                        wrap="nowrap"
                                    >
                                        <Grid item>{note.creator!.name}</Grid>
                                        <Grid item>{note.createdOn.toLocaleDateString()}</Grid>
                                    </Grid>
                                }
                            />
                        ) : (
                            <FullWidthField
                                name={`notes.${index}.text`}
                                rows={5}
                                multiline
                                fullWidth
                            />
                        )}
                        <ListItemSecondaryAction>
                            <IconButton
                                aria-label="delete"
                                onClick={this.archiveNote(arrayHelpers, index)}
                            >
                                <CloseIcon />
                            </IconButton>
                        </ListItemSecondaryAction>
                    </ListItem>
                </List>
            );
        });
    };

    public render() {
        const { notes, setFieldValue, noteGridStyle } = this.props;
        return (
            <>
                <Grid alignItems="center" container justify="space-around" wrap="nowrap">
                    <Grid item>Notes / Comments</Grid>
                    <Grid item>
                        <Fab
                            size="small"
                            color="primary"
                            aria-label="Add"
                            onClick={this.addNotes(setFieldValue, notes)}
                        >
                            <Add />
                        </Fab>
                    </Grid>
                </Grid>
                <div className={noteGridStyle}>{this.renderNotesArray(notes)}</div>
            </>
        );
    }
}
export default NotesInlineList;



// WEBPACK FOOTER //
// ./src/actionItems/NotesInlineList.tsx